{
  "name": "smb",
  "version": "1.0.0.30",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run stamp-build-metadata && ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:css": "node scripts/postcss-legacy-chrome.check.cjs",
    "test:ci": "npm run test:css && ng test --watch=false",
    "dev": "ng serve",
    "start:dev": "ng serve --configuration development",
    "start:stage": "ng serve --configuration staging",
    "start:prod": "ng serve --configuration production",
    "stamp-build-metadata": "node scripts/inject-build-metadata.mjs",
    "build:dev": "npm run stamp-build-metadata && ng build --configuration development",
    "build:stage": "npm run stamp-build-metadata && ng build --configuration staging",
    "build:prod": "npm run stamp-build-metadata && ng build --configuration production"
  },
  "private": true,
  "packageManager": "npm@10.9.8",
  "dependencies": {
    "@angular/common": "^22.0.0",
    "@angular/compiler": "^22.0.0",
    "@angular/core": "^22.0.0",
    "@angular/forms": "^22.0.0",
    "@angular/platform-browser": "^22.0.0",
    "@angular/router": "^22.0.0",
    "@angular/service-worker": "^22.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.8",
    "@angular/cli": "^22.0.8",
    "@angular/compiler-cli": "^22.0.0",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "@types/node": "^24.12.2",
    "typescript": "~6.0.2",
    "vitest": "^4.0.8",
    "tailwindcss": "^4.3.3",
    "@tailwindcss/postcss": "^4.3.3",
    "postcss": "^8.5.23",
    "lightningcss": "1.32.0"
  }
}
